<template>
  <header class="headerCom">
    <div class="row">
      <div class="header-wrap">

        <img
          class="logo"
          src="../../images/header/logo.png"
          alt="Logo"
          @click="gotmoldHome"
        />
        <transition>
          <div class="management-center"  v-if="['superadmin', 'admin'].includes(role) && admin" :style="['superadmin', 'admin'].includes(role) ? { flex: 1 } : {}">
            <span id='management-center' v-if="!lab">
            <!-- <ManagementList
              v-click-outside="closeModelList"
              @title="setTitle"

            ></ManagementList> -->
            <adminIndex></adminIndex>
            </span>
            <a class="lab-switch-link" @click="goToAdminDashboard" v-if="lab">Return to Admin</a>
          </div>
        </transition>
        <div
          class="burger-btn"
          :class="{ burgerOpened }"
          @click="burgerOpened = !burgerOpened"
          v-if="!admin && this.$route.name !== 'GetStarted'"
        >
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
        <ul
          class="header-menu"
          :class="{ headerMenuOpened: burgerOpened }"
          v-if="!admin && this.$route.name !== 'GetStarted' "
        >
          <li class="header-li-hover header-li-blue" @click="changePage('/home')" v-if="login">
            Dashboard
          </li>
          <li class="header-li-hover" @click="newKit" v-if="!admin && login">
            Activate a Kit
          </li>
          <li
            class="header-li-hover"
            @click="changePage('/activate')"
            v-if="!admin && !login && !activateKit"
          >
            Activate a Kit
          </li>
          <li
            class="header-li-blue"
            @click="changePage('/activate')"
            v-if="!admin && !login && activateKit"
          >
            Activate a Kit
          </li>
          <li
            class="header-li-hover"
            @click="changePage('https://www.gotmold.com/shop/', true)"
          >
            Shop
          </li>
          <li
            class="header-li-hover"
            @click="changePage('https://www.gotmold.com/#contact-us', true)"
          >
            Support
          </li>
          <li
            class="header-li-hover"
            @click="changePage('/self-service')"
          >
            Self Service
          </li>
          <li class="menu-item header-li-hover" @click="logout" v-if="login && !isAdmin">
            Logout
          </li>
          <li class="menu-item header-li-hover" @click="goToAdmin" v-if="isAdmin">
            Back To Admin
          </li>
        </ul>
          <img
            class="spore"
            src="../../images/bg/spore-blue.png"
            alt="Spore"
            ref="spore"
          :class="{ rotate: routeChange }"
          v-if="!admin"
        />
        <div id="burger-opened">
          <img  class="menu-img" @click="burgerOpened_2 = !burgerOpened_2" src="../../images/header/hamburger.png">
            <OptionsmMenu  
                  v-click-outside="closeModelList"
                  @title="setTitle"
                  class="options-menu"
                  v-if="['superadmin', 'admin'].includes(role) && burgerOpened_2">
            </OptionsmMenu>
        </div>
        <AdminHeader v-if="admin" />
      </div>
    </div>
  </header>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import AdminHeader from "./AdminHeader";
import ManagementList from "../menu/ManagementList";
import OptionsmMenu from "../menu/OptionsmMenu";
import adminIndex from "../menu/adminIndex.vue";
export default {
  name: "headerCom",
  data() {
    return {
      login: false,
      lab:false,
      details:false,
      admin: false,
      userProfile: [],
      burgerOpened: false,
      burgerOpened_2: false,
      showmenu:false,
      routeChange: false,
      activateKit: false,
      isAdmin:false,
      show: false,
      step:0,
      title: [
        "Test Kit Management",
        "Admin Management",
        "Lab Operator Management",
        "Research",
        "Outlier Kits",
        "Reports",
        "QR Code Generator",
        "Kit URL Generator",
        "Customers",
        "Federal Holidays",
        "",
        "Woo Orders",
        "Import Kits from CSV",
        "Import Inactive CSV",
      
      ],
      filters:[]
    };
  },
  components: {
    AdminHeader,
    ManagementList,
    OptionsmMenu,
    adminIndex
  },
  methods: {
    ...mapActions(["profile", "clearToken","backtoAdmin","adminLoginSet","setStatusFilter","setcloseModel","setComponentNum"]),
    closeModelList() {
      ///setcloseModel(false);
      this.show = false;
    },
    getClass() {
      if (this.show) {
        return "title"; // Add the class 'active'
      } else {
        return "title-selected"; // Add the class 'inactive'
      }
    },
    goToAdmin(){
      this.isAdmin=false;
      this.backtoAdmin();
      this.$router.push({ path: "/dashboard" });
    },
    goToAdminDashboard(){
      this.$store.commit("labLogined", false);
      this.$store.commit("serachString", null);
      this.$router.push({ path: "/dashboard" });
    },
    gotmoldHome() {
      if(this.$route.name == 'GetStarted') {
        window.open('https://www.gotmold.com/', '_blank');
      }else{
        this.$router.push('/');
      }
    },
    showTerms() {
      this.burgerOpened = false;
      this.$emit("showTerms", true);
    },
    newKit() {
      this.burgerOpened = false;
      this.$emit("newKit", { state: true, step: 0 });
    },
    logout() {
      this.burgerOpened = false;
      this.clearToken().then(res => {
        this.$router.push({ path: "/login" });
      });
    },
    stopPropagation(event) {
      event.stopPropagation();
    },
    changePage(page, go) {
      this.activateKit = true;
      if (go) window.open(page, "_blank");
      else {
        this.$router.push(page);
        this.burgerOpened = false;
      }
    },
    appendMetaAndTitleTags() {
      const titleTag = document.querySelector(".page-title");
      if (titleTag) titleTag.parentNode.removeChild(titleTag);
      if (this.admin) {
        if(this.lab){
          titleTag.innerHTML = `Lab Dashboard | GOT MOLD?`;
        } else {
          titleTag.innerHTML = `Admin Dashboard | GOT MOLD?`;
        }
      } else  if (this.login) {
        if(this.details){
           titleTag.innerHTML = `Project Details | GOT MOLD?`;
        } else {
        titleTag.innerHTML = `Dashboard | GOT MOLD?`;
        }
      } else {
         titleTag.innerHTML = `Activation & Login | GOT MOLD?`;
      }
      document.head.appendChild(titleTag);
    },
    setTitle(obj) {
      // if((typeof this.steps.steps !== 'undefined' && this.steps.steps !== obj.value && obj.value == 4)) {
      //   this.$emit("outlinerkits", {steps : obj.value});
      // }
      // if (
      //   obj.value === 0 &&
      //   obj.value !== this.step &&
      //   !this.steps.switchOrder
      // ) {
        this.filters = [];
        this.setStatusFilter(this.filters);
      //   this.shipped = false;
      //   this.activated = false;
      //   this.awaiting = false;
      //   this.received = false;
      //   this.hold = false;
      //   this.complete = false;
      //   this.problem = false;
      //   this.delivered = false;
      // }

      this.show = obj.show;
      this.step = obj.value;
      // this.analytics_header = { type: null, sub_type: null, button: false };
      this.setComponentNum(obj.value)
    },
  },
  created() {
    this.admin = this.adminLogin;
    this.lab = this.labLogin;
    this.appendMetaAndTitleTags();
  },
  computed: {
    ...mapGetters(["role","customerLogin", "adminLogin","labLogin","loading", "getStep","getDetails","getIsAdmin"])
  },
  watch: {
    $route() {
      this.routeChange = true;
      setTimeout(() => (this.routeChange = false), 1500);
    },
    getStep() {
      this.routeChange = true;
      setTimeout(() => (this.routeChange = false), 1500);
    },
    customerLogin(boolean) {
      this.login = boolean;
      this.appendMetaAndTitleTags();
    },
    adminLogin(boolean) {
      this.admin = boolean;
      this.appendMetaAndTitleTags();
    },
    labLogin(boolean) {
      this.lab = boolean;
      this.appendMetaAndTitleTags();
    },
    getDetails(boolean){
      this.details = boolean;
      this.appendMetaAndTitleTags();
    },
    getIsAdmin(boolean){
      this.isAdmin = boolean;
    },
    getAnalyticsStatus(obj) {
      if (
        obj !== "undefined" ||
        (obj.type !== "undefined" && obj.item !== "undefined")
      ) {
        this.step = obj.status;
        this.show = obj.show;
        if (obj.item !== null) {
          obj.item = obj.item
            .toLowerCase()
            .replace(/\b[a-z]/g, function(letter) {
              return letter.toUpperCase();
            });
        }
        this.analytics_header = {
          type: obj.type,
          sub_type: obj.item,
          button: obj.show,
          count: obj.count,
          total: obj.total
        };
      }
    },
  },
  async mounted(){
      await this.adminLoginSet();
      this.isAdmin = this.$store.getters.getIsAdmin;
  }
};
</script>

<style scoped lang="scss">
@import "../../styles/colors";
.rotate {
  animation-iteration-count: infinite;
  animation-duration: 1.5s;
  animation-name: slideIn;
}

@keyframes slideIn {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
.spore {
  width: 34px;
  height: 34px;
  position: absolute;
  right: 60px;
}
.headerCom {
  width: 100%;
  height: 100px;
  background-color: $white;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  font-family: TTNormsMedium, sans-serif;
}
.header-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 0 60px;
  position: relative;
  .burger-btn {
    display: none;
  }
  .logo {
    position: absolute;
    left: 60px;
    width: 175px;
    justify-self: start;
    cursor: pointer;
  }
  .management-center {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .header-menu {
    display: flex;
    font-size: 17px;
    font-weight: 500;
    * {
      cursor: pointer;
      color: #6b6b6b;
    }
    li {
      margin: 0 20px;
      -webkit-font-smoothing: antialiased;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }
  }
}
.lab-switch-link {
  color: #666;
  font-size: 17px;
  cursor: pointer;
  white-space: nowrap;
  margin-left: 20px;
  font-family: TTNormsMedium, sans-serif;
}
.lab-switch-link:hover {
  color: #0268b2;
  transition: 0.3s;
}
.header-li-hover:hover {
  color: #0268b2 !important;
  transition: 0.3s !important;
}
.header-li-blue {
  color: #0268b2 !important;
}
.row {
  display: flex;
  justify-content: space-between;
  height: 100%;
}
.title {
  color: #005eb8;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
  max-width: 412px;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 0 0 0 101px;;
  cursor: pointer;
  border-radius: 5px;
  padding: 10px;
  border: 1px solid #e7ecef;
  border-radius: 5px;
  background-color: #ffffff;
}
.title-selected {
  color: #fff;
  font-size: 18px;
  font-family: TTNormsMedium, sans-serif;
  max-width: 412px;
  width: 100%;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  margin: 0 0 0 101px;
  cursor: pointer;
  background-color: #005eb8;
  border-radius: 5px;
  border: 1px #005eb8;
  padding: 10px;
}
.drop-down-menu {
  margin: 0px 0px 0px 5px;
}
.title-down {
  height: 18px;
  cursor: pointer;
  vertical-align: top;
}
.menu-img {
  display: flex;
  justify-content: center;
  width:20px;
  height: auto;
  cursor: pointer;
}

.options-menu {
  position: absolute;
  top: 100%; /* Positions the menu just below the hamburger icon */
  right: 0;
  z-index: 1000; /* Ensure it appears above other elements */
  width: 250px; /* Adjust as needed to match your menu width */
  height: auto;
}
#burger-opened{
  display: none;
}
#management-center{
  display: block;
}

@media screen and (max-width: 1300px) {
  .management-center {
    justify-content: right !important;
    align-items: right !important;
  }
  .header-wrap{
    padding: 0 30px !important;
  }
  // #burger-opened{
  //   display: block;
  // }
  // #management-center{
  //   display: none;
  // }
}
@media screen and (max-width: 1057px) {
  
  .spore {
    width: 30px;
    height: 30px;
    right: 40px;
  }
  .headerCom {
    height: 70px;
  }
  .header-wrap {
    padding: 0 30px !important;
    justify-content: flex-end;
    .logo {
      width: 140px;
      position: absolute;
      left: 86px;
      justify-self: start;
      cursor: pointer;
      transform: translate(-50%);
    }
    .management-center {
      justify-content: right !important;
      align-items: right !important;
      position: relative;
    }
    .header-menu {
      display: flex;
      width: 100vw;
      background-color: rgba(255, 255, 255, 1);
      transition: 0.5s;
      top: 70px;
      left: -200%;
      position: absolute;
      flex-direction: column;
      align-items: center;
      padding: 60px 0;
      border-bottom-right-radius: 10px;
      border-bottom-left-radius: 10px;
      li {
        margin: 10px 0;
        font-size: 25px;
        text-align: center;
      }
    }
    .headerMenuOpened {
      left: 0;
      transition: 0.5s;
    }
    .burger-btn {
      width: 22px;
      height: 15px;
      display: flex;
      margin-right: 60px;
      flex-direction: column;
      justify-content: space-between;
      cursor: pointer;
      position: relative;
      .line {
        width: 100%;
        height: 3px;
        background-color: $blue;
      }
    }
    .burgerOpened {
      .line {
        transition: 0.5s;
        &:first-child {
          position: absolute;
          top: 5px;
          transform: rotate(45deg);
        }
        &:nth-child(2) {
          position: absolute;
          top: 5px;
          transform: rotate(-45deg);
        }
        &:last-child {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 975px) {
  // #burger-opened{
  //   display: block;
  // }
  // #management-center{
  //   display: none;
  // }
}
@media screen and (max-width: 370px) {
  .header-wrap {
    .logo {
      width: 40%;
    }
  }
}
</style>
